import { Component, OnInit } from '@angular/core';
import { Todo } from './todo.model';
import { LoadComponent } from '../ui-design-library/load/load.component';

@Component({
  selector: 'fnsr-todo-list',
  standalone: true,
  imports: [LoadComponent],
  templateUrl: './todo-list.component.html'
})
export class TodoListComponent implements OnInit {
  todos: Todo[] = [];


  ngOnInit(): void {
    this.todos = [
      {
        title: 'Redirects',
        description: 'redirects auch in db führen und ebenso tracken, wer wann wem welche Mail geschickt hat.Darin soll sich eine Tracking- ID befinden und / oder Tracking Pixel(vgl.KlickTipp, um zu sehen, ob diese jemand bekommen hat oder nicht. Außerdem die ganzen Anti - Spam - Maßnahmen vornehmen und sich bei KlickTipp dabei orientieren.'
      },
      {
        title: 'MediaElemente',
        description: 'MediaElemente für alle zugänglich machen und anzeigen, welche Tags verknüpft sind(also Worte aus Textdatei barmenia.fnsr.me) und ob und in welchen Mailvorlagen verwendet wird.'
      },
      {
        title: 'B24 Produktseite auf Verkaufshilfen (Mind. Top5) checken',
        description: 'als Info in Mail hinterlegen.Auszeichnungen von Auszeichnungsseite übernehmen und abgleichen(Python Beautiful Soup)'
      },
      {
        title: 'Bilder',
        description: 'Bilder max. 350 bzw. 400 breit(siehe iPhone - Bildschirmgrößen)'
      },
      {
        title: 'Url Shortener',
        description: 'auch für fnsr.me bzw. barmenia.fnsr.me verwenden und vor der Weiterleitung auf Erreichbarkeit zu prüfen und ggf.Fehlermeldung zu geben als auch Hinweis, dass Dokument einen Nachfolger hat und dort zu finden ist.Bei veralteten Dokument diese dann in iFrame anzeigen.und Aufrufe tracken'
      },
      {
        title: 'user state & User lastState',
        description: 'Status für die Agents einführen (mit Zahlen und Dropdown, um zu sehen, in welcher Stufe sich jemand befindet(Erstkontakt (tel.) erfolgt, Registrierung erfolgt, Um Bewertung gebeten, Bewertung abgegeben …'
      },
    ]
  }

}
